var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "sidecart_empty" },
    _vm._l(_vm.blocks, function (block) {
      return _c("div", {
        domProps: { innerHTML: _vm._s(_vm.blockToOutput(block)) },
      })
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }